import { Icon, VStack, Text } from '@cad-arc';
import React from 'react';

type IconTypes = React.ComponentProps<typeof Icon>['icon'];

export function NoMembersIndicator<Value>({
    value,
    icon,
    text,
    action,
}: {
    text: string;
    icon: IconTypes;
    action?: React.ReactNode;
    value?: Value;
}): React.ReactElement {
    return value && Array.isArray(value) && value.length === 0 ? (
        <VStack alignItems="center" mt={3} w="100%">
            <Icon icon={icon} size="md" color="text.placeholder" />
            <Text variant="headingXs">{text}</Text>
            {action ?? null}
        </VStack>
    ) : (
        <></>
    );
}
